<template>
  <div>
    <div class="mb-primary">
      <app-table :id="tableId"  :options="options" @action="getListAction" />
    </div>

      <vigilance-modal
      v-if="isAddEditModalActive"
      :modalTitle="modalTitle"
      :editModalTitle="editModalTitle"
      :table-id="tableId"
      :msgInfo="msgInfo"
      :msgType="msgType"
      :msgNote="msgNote"
      :accAppReplicaId="accAppReplicaId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
      modalId="vigilance-modal-start"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  name: "StartRenovation",
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      modalTitle: "Proceso vigilancia.",
      editModalTitle:  "Proceso vigilancia.",
      isAddEditModalActive: false,
      accAppReplicaId: Number,
      msgInfo: "",
      msgType: "",
      msgNote: "",
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "renovation-list",
      rowData: {},
      options: {
        url: `/vigilancesreview/vigilances/indexRenovation`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Iniciar proceso"),
            icon: "eye",
            type: "none",
            component: "vigilance-modal",
            modalId: "vigilance-modal-start",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    }
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
  },
  methods: {
    
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },


    closeAddEditModal() {
      $("#vigilance-modal-start").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("Iniciar proceso")) {
        this.selectedUrl = `/vigilancesreview/vigilances/${rowData.id}`;
        this.accAppReplicaId = rowData.id;
        this.msgNote = '';
          this.msgInfo = '¿Desea iniciar la '+ rowData.accreditation_type.name + " con código de expediente " + rowData.record + ' ?' ;
          if (rowData.accreditation_type.name.includes("Vigilancia")) {
            this.msgType = 'Vigilancia';
          }
          if (rowData.accreditation_type.name === "Renovación") {
            this.msgType = 'Renovación';
          }
          this.openAddEditModal();
        
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
  }
}
</script>

<style>

</style>